// @ts-nocheck

import React, { Component } from 'react';
import { connect } from 'react-redux';

import { clearCreativeImageUrl, uploadDiscoAdsCreative } from '../../../../actions/DiscoAdsActions';

import ImageUploader, { isImageSquare } from '../../../../../common/components/core/ImageUploader';

import { hasValidFileExtension } from '../../../../support/utils';

import type { Dispatch } from 'client/js/redux';
import { DA_CREATIVE_MAX_FILE_SIZE, DA_CREATIVE_VALID_FILE_EXTENSIONS } from '../../discoAdsConstants';

const doesImageFileMeetFileConstraints = async (imageFile) => {
  if (!imageFile) {
    return false;
  }
  const fileExtensionIsValid = hasValidFileExtension(imageFile.name, DA_CREATIVE_VALID_FILE_EXTENSIONS);
  const imageIsSquare = fileExtensionIsValid && (await isImageSquare(imageFile));
  if (!fileExtensionIsValid || imageFile.size > DA_CREATIVE_MAX_FILE_SIZE || !imageIsSquare) {
    return false; // error messages are rendered in downstream ImageUploader component
  }
  return true;
};

class DiscoAdsImageUploader extends Component {
  state = { imageFile: null };

  _onImageChange = (ev) => {
    if (ev.file) {
      this.setState(
        {
          imageFile: ev.file,
        },
        this._handleImageUpload
      );
    }
  };

  _handleImageUpload = async () => {
    const { uploadDiscoAdsCreative, clearCreativeImageUrl } = this.props;
    const { imageFile } = this.state;
    const imageFileMeetsFileConstraints = await doesImageFileMeetFileConstraints(imageFile);
    if (!imageFileMeetsFileConstraints) {
      // clear image url from redux in case user previously uploaded an image
      clearCreativeImageUrl();
      return;
    }
    uploadDiscoAdsCreative({ imageFile });
  };

  render() {
    return (
      <div>
        <ImageUploader
          testid="dac-creative-image-upload"
          enableFileToggle={false}
          enablePreview={false}
          onChange={this._onImageChange}
          validFileExtensions={DA_CREATIVE_VALID_FILE_EXTENSIONS}
          maxSize={DA_CREATIVE_MAX_FILE_SIZE}
          enforceSquare
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  uploadDiscoAdsCreative: ({ imageFile }) => {
    dispatch(uploadDiscoAdsCreative({ imageFile }));
  },
  clearCreativeImageUrl: () => {
    dispatch(clearCreativeImageUrl());
  },
});

const ConnectedDiscoAdsImageUploader = connect(null, mapDispatchToProps)(DiscoAdsImageUploader);

export default ConnectedDiscoAdsImageUploader;
